import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let task_id = useDataValue({
    context: 'task',
    path: 'id',
    viewPath: props.viewPath,
  })

  return function onChange(_, date) {
    submit({
      type: 'set_task_due_date',
      task_id,
      due_date: date,
    })
    props.closePopover()
  }
}
